<template>
  <div class="priceList" v-if="priceData">
    <table>
      <tr>
        <td>事前現場調査費</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.resrchPrice)}}</td>
      </tr>
      <tr>
        <td>消費税(10%)</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.resrchPriceTax)}}</td>
      </tr>
      <tr class="total upper_separator">
        <td>合計金額（税込）</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.resrchTotalPrice)}}</td>
      </tr>
    </table>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    priceData: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/ResrchPrice.vue